module.exports = __webpack_public_path__ + "img/Diploma.b4727fec.svg";